import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import Icon from '../../../components/AppIcon';

const ContextMenu = ({ isOpen, position, onClose, file, onDownload, onDelete, onShare, onPreview, onCopyUrl }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e) => {
      if (menuRef?.current && !menuRef?.current?.contains(e?.target)) {
        onClose();
      }
    };

    const handleEscape = (e) => {
      if (e?.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !file) return null;

  const menuItems = [
    { icon: 'Eye', label: 'Preview', action: onPreview },
    { icon: 'Download', label: 'Download', action: onDownload },
    { icon: 'Share2', label: 'Share', action: onShare },
    { icon: 'Copy', label: 'Copy URL', action: onCopyUrl },
    { divider: true },
    { icon: 'Trash2', label: 'Delete', action: onDelete, danger: true },
  ];

  return createPortal(
    <div
      ref={menuRef}
      className="fixed bg-card border border-border rounded-lg shadow-lg elevation-3 py-1 min-w-[180px] z-[120] animate-scale-in"
      style={{
        top: `${position?.y}px`,
        left: `${position?.x}px`,
      }}
    >
      {menuItems?.map((item, index) => {
        if (item?.divider) {
          return <div key={index} className="h-px bg-border my-1" />;
        }
        return (
          <button
            key={index}
            onClick={() => {
              item?.action?.();
              onClose();
            }}
            className={`w-full flex items-center gap-3 px-3 py-2 text-sm transition-colors duration-150 ${
              item?.danger
                ? 'text-error hover:bg-error/10' :'text-foreground hover:bg-muted'
            }`}
          >
            <Icon name={item?.icon} size={16} />
            <span>{item?.label}</span>
          </button>
        );
      })}
    </div>,
    document.body
  );
};

export default ContextMenu;